import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonSliderComponent } from './skeleton-slider/skeleton-slider.component';
import { SkeletonEngineComponent } from './skeleton-engine/skeleton-engine.component';
import { SkeletonCardHomeComponent } from './skeleton-card-home/skeleton-card-home.component';

@NgModule({
    declarations: [
        SkeletonSliderComponent,
        SkeletonEngineComponent,
        SkeletonCardHomeComponent
    ],
  exports: [
    SkeletonSliderComponent,
    SkeletonEngineComponent,
    SkeletonCardHomeComponent
  ],
  imports: [
    CommonModule,
  ]
})
export class HomePageSkeletonModule { }
